import { PPStatusData } from "@/picking-portal/models/PPStatusData";
import { ElementColors } from "@/common/theme/ElementColors";

export enum PPPaymentStatus {
  SUCCESSFUL = "SUCCESSFUL",
  CANCELLED = "CANCELLED",
  PENDING = "PENDING",
  PAID_AT_POS = "PAID_AT_POS",
  VOID_AT_POS = "VOID_AT_POS",
  NOT_INITIATED = "NOT_INITIATED",
}

const prefix = "modules.packing-portal.payment.status.";

export const PPPaymentStatusMap: Map<PPPaymentStatus, PPStatusData> = new Map<PPPaymentStatus, PPStatusData>([
  [PPPaymentStatus.SUCCESSFUL, { text: `${prefix}successful`, color: ElementColors.Chip.Successful }],
  [PPPaymentStatus.CANCELLED, { text: `${prefix}cancelled`, color: ElementColors.Chip.Cancelled }],
  [PPPaymentStatus.PENDING, { text: `${prefix}pending`, color: ElementColors.Chip.Pending }],
  [PPPaymentStatus.PAID_AT_POS, { text: `${prefix}paid-at-pos`, color: ElementColors.Chip.PaidAtPos }],
  [PPPaymentStatus.VOID_AT_POS, { text: `${prefix}void-at-pos`, color: ElementColors.Chip.VoidAtPos }],
  [PPPaymentStatus.NOT_INITIATED, { text: `${prefix}not-initiated`, color: ElementColors.Chip.NotInitiated }],
]);
